import { connect } from 'react-redux'
import * as actions from '../actions'

// Adds props.showError, props.showSuccess and props.dismissNotification
const withNotifications = connect(null, dispatch => ({
	showError: err => actions.showError(err)(dispatch),
	showSuccess: err => actions.showSuccess(err)(dispatch),
	dismissNotification: id => dispatch(actions.dismissNotification(id))
}))

export default withNotifications
